// Panel de novedades ("lo nuevo"): validación, filtrado por pantalla/ventana/vistas y recuerdo de lo ya visto.
// Las publicaciones son un JSON publicado junto a los videos. "Visto" se guarda por publicación en el navegador.

export const CLAVE_VISTAS = 'novedadesVistas';

const esTexto = (v) => typeof v === 'string' && v.trim() !== '';
const textoOCero = (v) => (esTexto(v) ? v : null);

/** Publicaciones bien formadas (id, fecha, título); `cuerpo` puede venir como texto o lista de párrafos. */
export function normalizarNovedades(datos) {
  const lista = datos && typeof datos === 'object' ? datos.publicaciones : null;
  if (!Array.isArray(lista)) return [];
  return lista
    .filter((p) => p && esTexto(p.id) && esTexto(p.fecha) && esTexto(p.titulo))
    .map((p) => ({
      id: p.id,
      fecha: p.fecha,
      titulo: p.titulo,
      cuerpo: (Array.isArray(p.cuerpo) ? p.cuerpo : [p.cuerpo]).filter(esTexto),
      etiqueta: textoOCero(p.etiqueta),
      resumen: textoOCero(p.resumen),
      destacada: p.destacada === true,
      imagen: textoOCero(p.imagen),
      tutorial: textoOCero(p.tutorial),
      mostrarEn: Array.isArray(p.mostrarEn) ? p.mostrarEn.filter(esTexto) : [],
      desde: textoOCero(p.desde),
      hasta: textoOCero(p.hasta),
    }));
}

const ordenarPorFecha = (lista) =>
  [...lista].sort((a, b) => (a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0));
const enVentana = (p, hoy) => (!p.desde || p.desde <= hoy) && (!p.hasta || p.hasta >= hoy);

/**
 * Publicaciones dentro de su ventana `desde`–`hasta` (inclusiva), la más nueva primero. Con `pantalla` se limita a
 * las que se muestran en esa pantalla. Es lo que alimenta el feed, el historial y la insignia.
 */
export function novedadesVigentes({ publicaciones, hoy, pantalla = null }) {
  return ordenarPorFecha(
    publicaciones.filter((p) => enVentana(p, hoy) && (!pantalla || p.mostrarEn.includes(pantalla)))
  );
}

/** Cuántas publicaciones vigentes (de cualquier pantalla) la persona aún no ha visto. */
export function contarSinLeer({ publicaciones, hoy, vistas }) {
  const vistasSet = new Set(vistas);
  return novedadesVigentes({ publicaciones, hoy }).filter((p) => !vistasSet.has(p.id)).length;
}

/**
 * Publicaciones que salen como panel emergente ahora: solo las `destacada`, de esta pantalla, vigentes y no vistas.
 * Lo demás vive en el feed del inicio y en el historial, sin interrumpir.
 */
export function novedadesPendientes({ publicaciones, pantalla, hoy, vistas }) {
  if (!pantalla) return [];
  const vistasSet = new Set(vistas);
  return novedadesVigentes({ publicaciones, hoy, pantalla }).filter(
    (p) => p.destacada && !vistasSet.has(p.id)
  );
}

/** Pantalla con panel de novedades según la ruta: el inicio del admin y Presupuestos; el resto, ninguna. */
export function pantallaDeRuta(pathname) {
  const ruta = String(pathname ?? '').replace(/\/+$/, '');
  if (ruta === '/admin') return 'admin-inicio';
  if (ruta === '/admin/budget') return 'presupuestos';
  return null;
}

// El almacenamiento puede fallar (ventana privada, datos bloqueados): nunca debe romper la pantalla.
export function leerVistas() {
  try {
    const v = JSON.parse(localStorage.getItem(CLAVE_VISTAS) ?? '[]');
    return Array.isArray(v) ? v.filter(esTexto) : [];
  } catch (e) {
    return [];
  }
}

export function marcarVistas(ids) {
  try {
    localStorage.setItem(CLAVE_VISTAS, JSON.stringify([...new Set([...leerVistas(), ...ids])]));
  } catch (e) {
    // sin almacenamiento: el panel volverá a salir, no pasa nada
  }
}
